<template>
  <div class="foot">
    <div @click="setSonUser" v-if="act === 1" class="loginAccount">
      {{ sonUser === 0 ? "主账号登录" : "子账号登录" }}
    </div>
    <div v-else>已有账号，<span @click="$emit('cahngeAct', 1)" class="toLogin">马上登录</span></div>
  </div>
</template>

<script>
export default {
  name: "footers",
  props: ["act", "sonUser"],
  methods: {
    setSonUser() {
      this.$emit("SetsonUser", this.sonUser === 0 ? 1 : 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.foot {
  margin: 0 auto;
  width: 100%;
  height: 50px;
  border-top: 2px solid #b0adb0;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  .loginAccount {
    cursor: pointer;
  }
  .toLogin {
    color: #1D52EB;
    cursor: pointer;
  }
}
</style>
